export default "__VITE_ASSET__BSLuin8s__"